import { render, staticRenderFns } from "./EditableComponentComplex.vue?vue&type=template&id=163d1838&scoped=true"
import script from "./EditableComponentComplex.vue?vue&type=script&lang=js"
export * from "./EditableComponentComplex.vue?vue&type=script&lang=js"
import style0 from "./EditableComponentComplex.vue?vue&type=style&index=0&id=163d1838&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163d1838",
  null
  
)

export default component.exports